import createIcon from '../../createIcon';

/**
 * @component @name SecurityUpdateGood
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMUg3QzUuOSAxIDUgMS45IDUgM1YyMUM1IDIyLjEgNS45IDIzIDcgMjNIMTdDMTguMSAyMyAxOSAyMi4xIDE5IDIxVjNDMTkgMS45IDE4LjEgMSAxNyAxWk0xNyAxOEg3VjZIMTdWMThaTTE2IDEwLjA1TDE0LjU5IDguNjRMMTEuMDUgMTIuMThMOS42NCAxMC43N0w4LjIzIDEyLjE4TDExLjA1IDE1TDE2IDEwLjA1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SecurityUpdateGood = createIcon('SecurityUpdateGood', [
  [
    'path',
    {
      d: 'M17 1H7C5.9 1 5 1.9 5 3V21C5 22.1 5.9 23 7 23H17C18.1 23 19 22.1 19 21V3C19 1.9 18.1 1 17 1ZM17 18H7V6H17V18ZM16 10.05L14.59 8.64L11.05 12.18L9.64 10.77L8.23 12.18L11.05 15L16 10.05Z',
      key: 'i5d96a',
    },
  ],
]);

export default SecurityUpdateGood;
